import React from 'react';
import classnames from 'classnames';

import AvailableItem from 'components/Possessions/components/AvailableItem';
import EquippedSlot from 'components/Possessions/components/EquippedSlot/EquippedSlotContainer';
import MediaMdUp from 'components/Responsive/MediaMdUp';

import categoryNameToHumanReadableCategoryName from 'utils/categoryNameToHumanReadableCategoryName';
import PossessionsContext from 'components/Possessions/PossessionsContext';
import { IQuality } from 'types/qualities';

export default function EquippedGroupComponent({
  availableQualities,
  isChanging,
  name,
}: Props) {
  return (
    <li
      className={classnames(
        'equipped-group',
        !!availableQualities.length || 'equipped-group--empty',
      )}
    >
      <div
        className={classnames(
          'equipped-group__heading',
          !availableQualities.length && 'equipped-group__heading--empty', // We want to hide headers for empty groups on small devices
        )}
      >
        <h2
          className="heading heading--2 equipped-group__name"
        >
          {categoryNameToHumanReadableCategoryName(name)}
        </h2>
        <MediaMdUp>
          <div className="equipped-item__container">
            <EquippedSlot name={name} isChanging={isChanging} />
          </div>
        </MediaMdUp>
      </div>
      {!!availableQualities.length && (
        <div
          className={classnames(
            'equipped-group__available',
            isChanging && 'equipped-group__available--is-changing',
          )}
        >
          <PossessionsContext.Consumer>
            {({ currentlyInStorylet }) => availableQualities.map(item => (
              <AvailableItem
                {...item}
                key={item.id}
                currentlyInStorylet={currentlyInStorylet}
              />
            ))}
          </PossessionsContext.Consumer>
        </div>
      )}
    </li>
  );
}

interface Props {
  availableQualities: IQuality[],
  equippedItem?: { id: number },
  isChanging: boolean,
  name: string,
}
